import PropTypes from "prop-types";
import Box from "@mui/material/Box";

/**
 * Casque spartiate de la taille d'une icône, pour la barre de navigation.
 * Mêmes tracés que le sigil du hero, mais pleins : à 24px un contour au trait
 * disparaît complètement. Il prend la couleur du texte via `currentColor`,
 * donc il suit le thème clair/sombre et l'état survolé sans réglage.
 */

/* Silhouette d'un seul tenant : cimier, calotte, couvre-joues et nasal.
   Les ouvertures du visage sont creusées par le contour lui-même, pas par des
   sous-tracés : elles débouchent en bas entre les deux pointes de joues. */
const SILHOUETTE =
  "M 57 16 C 57 13, 59 12, 62 12 L 78 12 C 81 12, 83 13, 83 16 L 81 60 " +
  "C 100 60, 120 78, 120 104 C 120 130, 112 172, 94 200 " +
  "C 102 175, 107 145, 109 116 L 88 116 L 88 125 L 77 125 L 77 170 " +
  "L 70 182 L 63 170 L 63 125 L 52 125 L 52 116 L 31 116 " +
  "C 33 145, 38 175, 46 200 C 28 172, 20 130, 20 104 " +
  "C 20 78, 40 60, 59 60 Z";

/* Les deux croissants sont des sous-tracés du même chemin : en `evenodd` ils
   se creusent dans la calotte au lieu de se poser dessus. */
const YEUX =
  "M 28 94 C 29 80, 46 70, 64 70 C 50 80, 36 92, 28 94 Z " +
  "M 112 94 C 111 80, 94 70, 76 70 C 90 80, 104 92, 112 94 Z";

function SpartanMark({ size }) {
  return (
    <Box
      component="svg"
      aria-hidden
      focusable="false"
      /* cadré au plus près du dessin pour ne pas perdre de place à cette taille */
      viewBox="12 4 116 204"
      sx={{
        width: size,
        height: size,
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
      }}
    >
      <path fill="currentColor" fillRule="evenodd" d={`${SILHOUETTE} ${YEUX}`} />
    </Box>
  );
}

SpartanMark.defaultProps = {
  size: "1.35rem",
};

SpartanMark.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SpartanMark;
